import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '@vds-core/icons';
/**
 * @ignore
 */

var renderSmallIcon = function renderSmallIcon(props) {
  var showDialog = props.showDialog,
      inverted = props.inverted,
      hovered = props.hovered,
      clicked = props.clicked,
      activeState = props.activeState,
      hoverState = props.hoverState,
      iconConfig = props.iconConfig,
      colorConfig = props.colorConfig,
      focused = props.focused,
      focusState = props.focusState,
      active = props.active,
      disabled = props.disabled,
      ariaLabel = props.ariaLabel,
      rest = _objectWithoutProperties(props, ["showDialog", "inverted", "hovered", "clicked", "activeState", "hoverState", "iconConfig", "colorConfig", "focused", "focusState", "active", "disabled", "ariaLabel"]);

  function _calculateWeight() {
    return (showDialog && hoverState || clicked && activeState) && !disabled;
  }

  function _calculateColor() {
    var iconColor = colorConfig.black;
    if (inverted) iconColor = colorConfig.white;
    if (active && activeState) iconColor = colorConfig.coolGray6;
    if (disabled && inverted) iconColor = colorConfig.coolGray10;
    if (disabled && !inverted) iconColor = colorConfig.coolGray3;
    return iconColor;
  }

  return /*#__PURE__*/React.createElement(Icon, {
    hasStroke: true,
    data: iconConfig,
    medium: _calculateWeight(),
    tabIndex: -1,
    name: "info",
    size: "small",
    color: _calculateColor(),
    focused: focused && !clicked && !showDialog && !disabled,
    focusState: focusState,
    inverted: inverted,
    ariaLabel: ariaLabel
  });
};
/**
 * @ignore
 */


var renderLargeIcon = function renderLargeIcon(props) {
  var showDialog = props.showDialog,
      inverted = props.inverted,
      hovered = props.hovered,
      clicked = props.clicked,
      activeState = props.activeState,
      hoverState = props.hoverState,
      iconConfig = props.iconConfig,
      colorConfig = props.colorConfig,
      focused = props.focused,
      focusState = props.focusState,
      keyboardFocused = props.keyboardFocused,
      active = props.active,
      disabled = props.disabled,
      ariaLabel = props.ariaLabel,
      rest = _objectWithoutProperties(props, ["showDialog", "inverted", "hovered", "clicked", "activeState", "hoverState", "iconConfig", "colorConfig", "focused", "focusState", "keyboardFocused", "active", "disabled", "ariaLabel"]);

  function _calculateWeight() {
    return (showDialog && hoverState || clicked && activeState) && !disabled;
  }

  function _calculateColor() {
    var iconColor = colorConfig.black;
    if (inverted) iconColor = colorConfig.white;
    if (active && activeState) iconColor = colorConfig.coolGray6;
    if (disabled && inverted) iconColor = colorConfig.coolGray10;
    if (disabled && !inverted) iconColor = colorConfig.coolGray3;
    return iconColor;
  }

  return /*#__PURE__*/React.createElement(Icon, {
    hasStroke: true,
    data: iconConfig,
    medium: _calculateWeight(),
    tabIndex: -1,
    name: "info",
    size: "medium",
    color: _calculateColor(),
    focused: focused && !clicked && !showDialog && !disabled,
    focusState: focusState,
    inverted: inverted,
    ariaLabel: ariaLabel
  });
}; // secondary is destructured here so we don't write a boolean to the DOM will cause PropTypes
// eslint-disable-next-line no-unused-vars

/**
 * @ignore
 */


var AnchorIcon = function AnchorIcon(props) {
  var secondary = props.secondary;
  return /*#__PURE__*/React.createElement(Fragment, null, props.size === 'small' ? renderSmallIcon(props) : renderLargeIcon(props));
};

AnchorIcon.propTypes = {
  size: PropTypes.string,
  inverted: PropTypes.bool,
  focused: PropTypes.bool,
  focusState: PropTypes.bool
};
AnchorIcon.defaultProps = {
  size: 'large',
  inverted: false,
  focused: false,
  focusState: false
};
export default AnchorIcon;